export default "__VITE_ASSET__ChIO5rBe__"